import { ReactElement, useContext } from "react"

import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { NON_SYS_ADMIN_HP_STEPS_AMEND } from "../../formSpecs/hpSpec"
import { AmendHpDeviceContext } from "../providers/baseProviders/amendHpDeviceProvider"

/** AppStepper for amending an EVDC device */
const AmendHpDeviceProgressStepper = (): ReactElement => {
    const { currentIndex } = useContext(AmendHpDeviceContext)

    return (
        <AppStepper
            stepLabels={NON_SYS_ADMIN_HP_STEPS_AMEND}
            currentStepIndex={currentIndex}
        />
    )
}

export default AmendHpDeviceProgressStepper
